module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_8023.77fea56f.png";